 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		63: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		63: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"consumer-card-messaging~promotion-products-lazy~questions-and-answers~quick-view~ratings-and-reviews~049f7e1e","5":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"augmented-reality~quick-view~stylequiz~write-a-review-form","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"consumer-card-messaging~questions-and-answers~size-guide-overlay","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"promotion-products-lazy~quick-view~ratings-and-reviews","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"buybox~promotion-products-lazy","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"StoreLayout","16":"add-to-list-drawer","17":"aisle-bay","18":"augmented-reality","19":"bath-renovation","20":"breadcrumbs","21":"browse-and-search","22":"browse-and-search-mobile","23":"buybox","24":"collections","25":"collections-mobile","26":"common","27":"compare","28":"consumer-card-messaging","29":"customer-image-overlay","30":"drawer","31":"emt-generated-content","32":"emt-links","33":"emt-questions-and-answers-component","34":"fbr","35":"global-custom-configurator","36":"hammerjs","38":"home","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"order-sample","45":"order-sample-drawer","46":"overlay","47":"paint-reorder","48":"paint-reorder-mobile","49":"pep","50":"pep-mobile","51":"product","52":"product-mobile","53":"product-overview","54":"promotion-products-lazy","55":"question","56":"questions-and-answers","57":"quick-view","58":"ratings-and-reviews","59":"ratings-and-reviews-desktop","60":"ratings-and-reviews-mobile","61":"results","62":"returns-messaging","64":"share-to-email-overlay","65":"share-to-pinterest-overlay","66":"size-guide-overlay","67":"specifications","68":"stylequiz","69":"super-sku","70":"vendor-collection-products","71":"vendor-collections","72":"vendor-collections-mobile","74":"video-player","75":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"72c316804350afe72193","1":"da017c2ed9aafcd07b09","2":"c0f62e746d3bd8a34722","3":"15eef688a3893dbe27b6","4":"70a9638215f9eaedbe2a","5":"f9f467d872b3e97ad047","6":"f50762061b0e204c79a2","7":"45fd32ec371a9122c662","8":"c8bc6722b6e9a156f678","9":"ca893f3a50769bf3ef0a","10":"fd98d144e4a5a42fa6c9","11":"ebe602cebd1bfaf0958b","12":"9fa5ab0561da6cc2f7d0","13":"04d5c68530f343743daa","14":"b86ccdfcebd565e85ee4","15":"23c3c3277d250420422b","16":"6a72dae127cc40844062","17":"7760564a30697fe4ee55","18":"d1d6b6524f4dfdf877cf","19":"977a87eb6a2927458201","20":"304eca810586c6147b49","21":"e781136a0f5d80077f70","22":"dccb45e00413e5e17d37","23":"d94298c4ab85e058fd7a","24":"97cb314e17461f59f790","25":"ea7d6d104a33d19b8cd8","26":"3dc7f6a2e533f8678f8f","27":"9a2aeeb971d4bff4a524","28":"ec00962b3691f7a6293c","29":"49409feac782a3edb02f","30":"70b88ddafa0178a33a0f","31":"b24ebdadac43ce2d41ad","32":"ad29739b0058ccef9ff7","33":"e24d90481d3e55b5b62f","34":"456965fec57f057a5777","35":"f5943c4fb60e82eb16f4","36":"42db0d034daf669eabae","38":"a8686641b738a2f11a2b","39":"860413fc2643e3191309","40":"f54caa635eecd830d590","41":"bf6590cd2f2f2c72b675","42":"f0509c8bc726f510e145","43":"909b3fedc1a0b6d5b560","44":"19576eaa9a5d2d38072e","45":"2bfb61c52bd99698c738","46":"bef5da87c5223b285d03","47":"bcf6dcf8a97818be0985","48":"a5fb1133f80eab71a786","49":"e692901c9af6e022e93e","50":"051c296ed4bca9e75cda","51":"099ec14f626f74af4872","52":"faf6a42ca2573e60b714","53":"30ebf18962155803b783","54":"ee8085338bab272f1238","55":"df001963480072573f4d","56":"a11b20c90f744b17bbfd","57":"1f303b8da718136181b6","58":"d38746cd46971b607361","59":"82cab463b7396ba64c7d","60":"762881384e5f328d3996","61":"af4f3b2ad18b2c4ff3bc","62":"506d330c14b3d58071a6","64":"9bd8178204cb60f4e8c6","65":"7fd9338e9f681a285938","66":"947c7bc579db01c2828a","67":"2f886e58035ce923db64","68":"b984e43e8c3eb544275e","69":"2f00a14006ddb6b6a6ca","70":"491b4403a0eb84331f5f","71":"0dbaf072d8da8d395acd","72":"c7778525bc6409167804","74":"f909068f9a3ff7442a65","75":"00ae8f2fbfa93e3d4c8d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"5":1,"7":1,"9":1,"10":1,"11":1,"14":1,"17":1,"18":1,"19":1,"21":1,"22":1,"23":1,"24":1,"25":1,"27":1,"28":1,"29":1,"30":1,"31":1,"34":1,"35":1,"41":1,"42":1,"43":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"56":1,"57":1,"58":1,"60":1,"64":1,"65":1,"66":1,"68":1,"69":1,"70":1,"71":1,"72":1,"74":1,"75":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"consumer-card-messaging~promotion-products-lazy~questions-and-answers~quick-view~ratings-and-reviews~049f7e1e","5":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"augmented-reality~quick-view~stylequiz~write-a-review-form","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"consumer-card-messaging~questions-and-answers~size-guide-overlay","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"promotion-products-lazy~quick-view~ratings-and-reviews","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"buybox~promotion-products-lazy","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"StoreLayout","16":"add-to-list-drawer","17":"aisle-bay","18":"augmented-reality","19":"bath-renovation","20":"breadcrumbs","21":"browse-and-search","22":"browse-and-search-mobile","23":"buybox","24":"collections","25":"collections-mobile","26":"common","27":"compare","28":"consumer-card-messaging","29":"customer-image-overlay","30":"drawer","31":"emt-generated-content","32":"emt-links","33":"emt-questions-and-answers-component","34":"fbr","35":"global-custom-configurator","36":"hammerjs","38":"home","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"order-sample","45":"order-sample-drawer","46":"overlay","47":"paint-reorder","48":"paint-reorder-mobile","49":"pep","50":"pep-mobile","51":"product","52":"product-mobile","53":"product-overview","54":"promotion-products-lazy","55":"question","56":"questions-and-answers","57":"quick-view","58":"ratings-and-reviews","59":"ratings-and-reviews-desktop","60":"ratings-and-reviews-mobile","61":"results","62":"returns-messaging","64":"share-to-email-overlay","65":"share-to-pinterest-overlay","66":"size-guide-overlay","67":"specifications","68":"stylequiz","69":"super-sku","70":"vendor-collection-products","71":"vendor-collections","72":"vendor-collections-mobile","74":"video-player","75":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"6d6adccb060e560ac76a","2":"b9baafc99686dd5b3a47","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"1bbba36598b8be1d0d8d","6":"31d6cfe0d16ae931b73c","7":"0ef658ad0521bc70e648","8":"31d6cfe0d16ae931b73c","9":"dc0bc626ca15ffc94f61","10":"0a20f8e5f11ff87a10cb","11":"65f1d7aedc445dc5836f","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"2a3ec231f3c912a1ac3c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"d94b956aa532c1a50c65","18":"aaea7e50ac08080e9983","19":"b16dd7af580bb9e41771","20":"31d6cfe0d16ae931b73c","21":"1ae348110dc34ec83aed","22":"669cee34ef165ca1a626","23":"d688937a6fdd7b37db31","24":"b198ac565e58751ea7d1","25":"5803c7a68b5c7b340cd2","26":"31d6cfe0d16ae931b73c","27":"a6de817ebac7ecf3c5e3","28":"b2abe5e27db4122cb358","29":"c25839f6c71daeba8a8b","30":"5521673608a60d69edf8","31":"ce60225b3df70c962731","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"88e24c7aafcf93ae6cc6","35":"1a5562a08d12f7682989","36":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"7f370c410e7f4d80bcb7","42":"fa694f2a72bf88e8af8a","43":"c2f1f79743728dcb3d1b","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"263a36d3a498f3392915","47":"f3bdd1ef1ca15a174dd8","48":"c8ad5aa5462b29f9a48c","49":"e8e5147a28f066197432","50":"8c3de119c3cfde31a693","51":"d021094184cdfb4a9820","52":"59eeda8e4f02614ff156","53":"be155bb5d11dacdc4bb8","54":"48f2385f148c21e27ad8","55":"31d6cfe0d16ae931b73c","56":"dde2e386d080973cb341","57":"2f285f18fa9425b56df9","58":"330110710220fe732a7a","59":"31d6cfe0d16ae931b73c","60":"f38aaee08af9e508beb8","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","64":"93c24c1ca7761bd73490","65":"97864c525dcaa2e62562","66":"453dfc2640779a848cc6","67":"31d6cfe0d16ae931b73c","68":"c967612d15209b03606c","69":"56b7b2c5b68f181fe045","70":"f9e84e0f4a3e7aad8394","71":"d294eb25ad33081e2d74","72":"9afa407f11a4190f4fa7","74":"4f5b608ec38d0792d47e","75":"befa4515ee94d4de09c6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
